import { render } from "./Busy.vue?vue&type=template&id=6f106912&scoped=true"
import script from "./Busy.vue?vue&type=script&lang=js"
export * from "./Busy.vue?vue&type=script&lang=js"

import "./Busy.vue?vue&type=style&index=0&id=6f106912&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f106912"]])

export default __exports__